<cue-declarative-map-marker
  className="controllableMarker"
  pane="control-monitor"
  [zIndexOffset]="focused() ? activeZIndexOffset : 0"
  [geoJson]="unitObject().geometry"
>
  <div
    *cueDeclarativeMapMarkerTemplate
    class="map-unit-object-container"
    [class.center-to-poi]="centerObjectToPOI()"
    [class.is-zoomed-out]="isZoomedOut()"
    [class.map-unit-object-container--layout-scaled]="hasVisibleValueInput()"
    [style.-webkit-transform]="hasVisibleValueInput() ? null : scale()"
    [style.transform]="hasVisibleValueInput() ? null : scale()"
    [style.--map-unit-scale]="scaleFactor()"
    [ngStyle]="{
      '--custom-rgb': customRgb(),
      '--custom-rgba': customRgba(),
      '--custom-rgba-saturated': customRgbaSaturated(),
      '--automatic-text-color': automaticTextColor(),
    }"
  >
    @for (controllableItem of showableItemList(); track controllableItem.objectId; let controllableItemIndex = $index) {
      <div
        class="wrapper"
        [attr.data-cy]="'navigation-map-controllable-object-' + controllableItem.objectId"
        [style.margin-top.px]="marginFromPOIPixels()"
        [class.wrapper--layout-scaled-value-input]="controllableItem.showValueInput"
        [style.--wrapper-layout-scale]="scaleFactor() * controllableItem.objectScale"
        [style.zoom]="
          !controllableItem.showIndicator && !controllableItem.showValueInput
            ? (hasVisibleValueInput() ? scaleFactor() : 1) * controllableItem.objectScale
            : null
        "
        [style.transform]="
          controllableItem.showIndicator
            ? 'scale(' +
              (hasVisibleValueInput() ? scaleFactor() * controllableItem.objectScale : controllableItem.objectScale) +
              ')'
            : null
        "
        [class.toggled]="!controllableItem.open"
        [class]="controllableItem.data?.type"
        [class.one-item]="controllableItem.oneItem"
        [class.one-column]="controllableItem.oneColumn"
      >
        @if (controllableItem.showMonitor) {
          <div
            class="section section--monitor pointer-events-auto cursor-pointer"
            (click)="click.emit()"
            [class.no-title]="!controllableItem.showObjectLabel"
          >
            @if (controllableItem.foldingEnabled) {
              <cue-icon
                [class.flipped]="!controllableItem.open"
                [icon]="ICONS.cueArrowUp"
                (click)="onToggleClicked($event, controllableItem)"
                class="toggle-button"
              />
            }

            @if (controllableItem.showObjectLabel) {
              <h2 class="title">{{ controllableItem.data.label | cmLocalizedString }}</h2>
            }
            <div class="content">
              @for (item of controllableItem.data.item ?? []; track item.id) {
                <div class="item" [class.has-color]="item.hasColor">
                  <div class="item__icon-wrapper">
                    @if (item.showIcon) {
                      <cue-icon
                        [icon]="item.iconUrl"
                        [customIconClass]="'item__icon'"
                        [ngStyle]="{
                          'background-color': item.iconBackgroundColor,
                          '--automatic-icon-color': item.automaticIconColor,
                        }"
                      />
                    } @else if (item.showColor) {
                      <span
                        class="color-icon"
                        [ngStyle]="{
                          'background-color': item.color,
                        }"
                      ></span>
                    }
                  </div>
                  @if (item.showValue) {
                    <span class="item__value">{{ item.value | cmLocalizedString }}</span>
                  }
                  @if (item.showUnit) {
                    <span class="item__unit">{{ item.unit | cmLocalizedString }}</span>
                  }
                  @if (item.showLabel) {
                    <span class="item__label">{{ item.label | cmLocalizedString }}</span>
                  }
                </div>
              }
            </div>
          </div>
        } @else if (controllableItem.showControl) {
          <div class="section section--control pointer-events-auto cursor-pointer" (click)="click.emit()">
            @if (controllableItem.foldingEnabled) {
              <cue-icon
                [icon]="ICONS.cueArrowUp"
                [class.flipped]="!controllableItem.open"
                (click)="onToggleClicked($event, controllableItem)"
                class="toggle-button"
              />
            }
            @if (controllableItem.showLabel) {
              <h2 class="title" [class.no-spacing]="controllableItem.noSpacing">
                {{ controllableItem.data.label | cmLocalizedString }}
              </h2>
            }

            @if (controllableItem.canShowHidableControl) {
              @if (
                (controllableItem.data.message.text | cmLocalizedString) &&
                controllableItem.data.message?.type !== messageTypeEnum.Nothing
              ) {
                <div class="message {{ controllableItem.data.message.type }}">
                  @if (controllableItem.data.message.iconUrl || controllableItem.data.message.type) {
                    <cue-icon [icon]="controllableItem.controlIcon" customIconClass="message-icon" />
                  }
                  {{ controllableItem.data.message.text | cmLocalizedString }}
                </div>
              }

              <div class="content">
                @for (groupItem of controllableItem.data?.group; track groupItem.id) {
                  <div class="group">
                    <!--      GROUPA PRO OVLADACI PRVKY-->
                    @if (groupItem.label) {
                      <h3 class="group-title">{{ groupItem.label | cmLocalizedString }}</h3>
                    }

                    @if (
                      (groupItem.message.text | cmLocalizedString) &&
                      groupItem.message?.type !== messageTypeEnum.Nothing
                    ) {
                      <div class="message {{ groupItem.message.type }}">
                        @if (groupItem.message.iconUrl || groupItem.message.type) {
                          <cue-icon
                            [icon]="groupItem.message.iconUrl ?? getDefaultIconAccordingStatus(groupItem.message?.type)"
                            [customIconClass]="'message-icon'"
                          />
                        }

                        {{ groupItem.message.text | cmLocalizedString }}
                      </div>
                    }
                    <!--      JEDNOTLIVE PRVKY-->
                    <div class="group-items">
                      @for (item of groupItem.item; track item) {
                        @if (item.type === 'pushButton') {
                          <button
                            cue-button
                            variant="control"
                            [disabled]="item.state !== 'enabled'"
                            class="{{ item.indication }}"
                            [class.with-icon]="item.iconUrl"
                            [class.icon-only]="!item.label && !item.value && !item.unit"
                            (click)="performAction(item, controllableItem.objectId, $event)"
                          >
                            @if (item.iconUrl) {
                              <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                            }
                            @if (item.label || item.value || item.unit) {
                              <span class="label-and-value">
                                @if (item.label) {
                                  <span class="label" [class.label-only]="!(item.value || item.unit)">{{
                                    item.label | cmLocalizedString
                                  }}</span>
                                }
                                @if (item.value || item.unit) {
                                  <span class="value-and-unit">
                                    @if (item.value) {
                                      <span class="value">{{ item.value | cmLocalizedString }} </span>
                                    }
                                    @if (item.unit) {
                                      <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                                    }
                                  </span>
                                }
                              </span>
                            }
                          </button>
                        }
                        @if (item.type === 'hidden') {
                          <div class="hidden-btn"></div>
                        } @else if (item.type === 'repeatButton') {
                          <button
                            cue-button
                            (mouseleave)="repeatButtonEnd(item, $event)"
                            (mousedown)="repeatButtonStart(item, controllableItem.objectId, $event)"
                            (mouseup)="repeatButtonEnd(item, $event)"
                            variant="control"
                            [disabled]="item.state !== 'enabled'"
                            class="{{ item.indication }} repeat"
                            [class.with-icon]="item.iconUrl"
                          >
                            @if (item.iconUrl) {
                              <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                            }
                            @if (item.label || item.value || item.unit) {
                              <span class="label-and-value">
                                @if (item.label) {
                                  <span class="label" [class.label-only]="!(item.value || item.unit)">{{
                                    item.label | cmLocalizedString
                                  }}</span>
                                }
                                @if (item.value || item.unit) {
                                  <span class="value-and-unit">
                                    @if (item.value) {
                                      <span class="value">{{ item.value | cmLocalizedString }} </span>
                                    }
                                    @if (item.unit) {
                                      <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                                    }
                                  </span>
                                }
                              </span>
                            }
                          </button>
                        } @else if (item.type === 'value') {
                          <div class="value-type">
                            @if (item.label) {
                              <span class="label">{{ item.label | cmLocalizedString }}</span>
                            }
                            <span class="value">
                              @if (item.value) {
                                <span>{{ item.value | cmLocalizedString }}</span>
                              }
                              @if (item.unit) {
                                <span>{{ item.unit | cmLocalizedString }}</span>
                              }
                            </span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        } @else if (controllableItem.showValueInput) {
          <div class="section section--value-input pointer-events-auto cursor-pointer" (click)="click.emit()">
            @if (controllableItem.foldingEnabled) {
              <cue-icon
                [icon]="ICONS.cueArrowUp"
                [class.flipped]="!controllableItem.open"
                (click)="onToggleClicked($event, controllableItem)"
                class="toggle-button"
              />
            }

            @if (canShowValueInputObjectLabel(controllableItem)) {
              <h2 class="title">{{ controllableItem.data.label | cmLocalizedString }}</h2>
            }

            <div class="content">
              @for (item of controllableItem.data.item; track item.id) {
                @if (item.showLabel || item.showValue || item.showUnit || (item.showLimits && hasInputLimits(item))) {
                  <div
                    class="value-input-item"
                    [class.value-input-item--with-arrows]="isNumberInputType(controllableItem.data?.type)"
                  >
                    <div class="value-input-item__main">
                      @if (
                        item.showLabel ||
                        (isNumberInputType(controllableItem.data?.type) && item.showLimits && hasInputLimits(item))
                      ) {
                        <div class="value-input-item__label-row">
                          @if (item.showLabel) {
                            <span
                              class="value-input-item__label"
                              [attr.data-cy]="
                                'navigation-map-controllable-item-label-' + controllableItem.objectId + '-' + item.id
                              "
                              >{{ item.label | cmLocalizedString }}</span
                            >
                          }
                          @if (
                            isNumberInputType(controllableItem.data?.type) && item.showLimits && hasInputLimits(item)
                          ) {
                            @let allowedValueRange =
                              'monitorAndControl.allowedValueRange' | transloco: { range: getInputLimitsText(item) };
                            <button
                              type="button"
                              class="value-input-item__limits-tooltip-button"
                              [attr.aria-label]="allowedValueRange"
                              [cueTooltip]="allowedValueRange"
                              cueTooltipCommonType="info"
                              [cueTooltiptOptions]="{ trigger: 'click' }"
                              [cueTooltipHasBackdrop]="true"
                              cueTooltipBackdropClass="cdk-overlay-transparent-backdrop"
                              (click)="stopEditableInputEvent($event)"
                            >
                              <cue-icon [icon]="ICONS.cueInfo" />
                            </button>
                          }
                        </div>
                      }

                      <div
                        class="value-input-item__value-row"
                        [class.value-input-item__value-row--slider]="isSliderType(controllableItem.data?.type)"
                        [class.value-input-item__value-row--with-number-error]="
                          hasNumberInputRangeError(controllableItem.objectId, item.id)
                        "
                        [class.value-input-item__value-row--with-limits-tooltip]="
                          isNumberInputType(controllableItem.data?.type) && item.showLimits && hasInputLimits(item)
                        "
                      >
                        @if (isSliderType(controllableItem.data?.type) && item.showValue) {
                          <div class="value-input-item__slider-row">
                            <button
                              type="button"
                              variant="outlined"
                              cue-button
                              class="value-input-item__slider-button value-input-item__slider-button--decrease icon-only square"
                              [attr.data-cy]="
                                'navigation-map-controllable-slider-min-step-' +
                                controllableItem.objectId +
                                '-' +
                                item.id
                              "
                              [disabled]="isSliderAtMin(item)"
                              cueRepeatPress
                              (cueRepeatPress)="
                                stepSliderValue(controllableItem.objectId, item, getSliderMinStepDirection(item))
                              "
                            >
                              <cue-icon [icon]="ICONS.cueMinus" [customIconClass]="'icon'" />
                            </button>
                            <kendo-slider
                              [cueSliderDirection]="isSliderReversed(item) ? 'rtl' : 'ltr'"
                              class="value-input-item__slider"
                              [attr.data-cy]="
                                'navigation-map-controllable-slider-' + controllableItem.objectId + '-' + item.id
                              "
                              [min]="getSliderLowerBound(item)"
                              [max]="getSliderUpperBound(item)"
                              [smallStep]="getSliderStep(item)"
                              [showButtons]="false"
                              [ngModel]="getSliderValue(item)"
                              [ngModelOptions]="{ standalone: true }"
                              (click)="stopEditableInputEvent($event)"
                              (valueChange)="onSliderValueChanged(controllableItem.objectId, item.id, $event)"
                            ></kendo-slider>
                            <button
                              type="button"
                              variant="outlined"
                              cue-button
                              class="value-input-item__slider-button value-input-item__slider-button--increase icon-only square"
                              [attr.data-cy]="
                                'navigation-map-controllable-slider-max-step-' +
                                controllableItem.objectId +
                                '-' +
                                item.id
                              "
                              [disabled]="isSliderAtMax(item)"
                              cueRepeatPress
                              (cueRepeatPress)="
                                stepSliderValue(controllableItem.objectId, item, getSliderMaxStepDirection(item))
                              "
                            >
                              <cue-icon [icon]="ICONS.cuePlus" [customIconClass]="'icon'" />
                            </button>
                          </div>
                        } @else if (isTimeInputType(controllableItem.data?.type) && item.showValue) {
                          <assist-timepicker
                            class="value-input-item__time-picker"
                            [attr.data-cy]="
                              'navigation-map-controllable-time-' + controllableItem.objectId + '-' + item.id
                            "
                            [format]="'HH:mm'"
                            [steps]="{ hour: 1, minute: 1 }"
                            [value]="getTimePickerValue(item)"
                            enterKeyBehavior="blur"
                            (click)="stopEditableInputEvent($event)"
                            (valueCommit)="commitTimePickerValue(controllableItem.objectId, item.id, $event)"
                          />
                        } @else if (isNumberInputType(controllableItem.data?.type) && item.showValue) {
                          <kendo-numerictextbox
                            [autoCorrect]="false"
                            [format]="
                              isDoubleNumberInputType(controllableItem.data?.type) ? '0.####################' : 'n0'
                            "
                            #longNumberInput="kendoNumericTextBox"
                            cueNumericSpinnerChange
                            class="value-input-item__number-input"
                            [attr.data-cy]="
                              'navigation-map-controllable-number-' + controllableItem.objectId + '-' + item.id
                            "
                            [class.k-invalid]="hasNumberInputRangeError(controllableItem.objectId, item.id)"
                            [min]="item.minimum"
                            [max]="item.maximum"
                            [step]="item.step ?? 1"
                            [value]="getInputValue(item)"
                            [attr.aria-invalid]="
                              hasNumberInputRangeError(controllableItem.objectId, item.id) ? 'true' : null
                            "
                            (click)="stopEditableInputEvent($event)"
                            (cueNumericSpinnerChange)="
                              commitNumberValue(controllableItem.objectId, item, $event, controllableItem.data?.type)
                            "
                            (blur)="
                              commitNumberValue(
                                controllableItem.objectId,
                                item,
                                longNumberInput.value,
                                controllableItem.data?.type
                              )
                            "
                            (keydown.enter)="
                              commitNumberValue(
                                controllableItem.objectId,
                                item,
                                longNumberInput.value,
                                controllableItem.data?.type
                              )
                            "
                          ></kendo-numerictextbox>
                          @if (hasNumberInputRangeError(controllableItem.objectId, item.id)) {
                            <span
                              class="value-input-item__number-error"
                              aria-live="polite"
                              [attr.data-cy]="
                                'navigation-map-controllable-number-error-' + controllableItem.objectId + '-' + item.id
                              "
                            >
                              {{ 'monitorAndControl.valueOutsideAllowedRange' | transloco }}
                            </span>
                          }
                        }
                        @if (
                          !isSliderType(controllableItem.data?.type) &&
                          ((!isValueInputType(controllableItem.data?.type) && item.showValue && hasInputValue(item)) ||
                            (!isTimeInputType(controllableItem.data?.type) && item.showUnit))
                        ) {
                          <div class="value-input-item-text">
                            @if (
                              !isValueInputType(controllableItem.data?.type) && item.showValue && hasInputValue(item)
                            ) {
                              <span class="value-input-item__value">{{ getInputValue(item) }}</span>
                            }
                            @if (!isTimeInputType(controllableItem.data?.type) && item.showUnit) {
                              <span class="value-input-item__unit">{{ item.unit | cmLocalizedString }}</span>
                            }
                          </div>
                        }

                        @if (isSliderType(controllableItem.data?.type)) {
                          <div class="value-input-item__slider-footer">
                            @if (item.showLimits && hasInputLimits(item)) {
                              <button
                                type="button"
                                class="value-input-item__slider-limit value-input-item__slider-limit--min"
                                [disabled]="isSliderAtMin(item)"
                                (click)="
                                  stopEditableInputEvent($event); setSliderToMin(controllableItem.objectId, item)
                                "
                              >
                                {{ getSliderMin(item) }}
                              </button>
                            } @else {
                              <span class="value-input-item__slider-limit-spacer"></span>
                            }

                            @if ((item.showValue && hasInputValue(item)) || item.showUnit) {
                              <span
                                class="value-input-item__slider-current"
                                [attr.data-cy]="
                                  'navigation-map-controllable-slider-current-' +
                                  controllableItem.objectId +
                                  '-' +
                                  item.id
                                "
                              >
                                @if (item.showValue && hasInputValue(item)) {
                                  <span class="value-input-item__value">{{ getInputValue(item) }}</span>
                                }
                                @if (item.showUnit && item.unit) {
                                  <span class="value-input-item__unit">{{ item.unit | cmLocalizedString }}</span>
                                }
                              </span>
                            } @else {
                              <span class="value-input-item__slider-current"></span>
                            }

                            @if (item.showLimits && hasInputLimits(item)) {
                              <button
                                type="button"
                                class="value-input-item__slider-limit value-input-item__slider-limit--max"
                                [disabled]="isSliderAtMax(item)"
                                (click)="
                                  stopEditableInputEvent($event); setSliderToMax(controllableItem.objectId, item)
                                "
                              >
                                {{ getSliderMax(item) }}
                              </button>
                            } @else {
                              <span class="value-input-item__slider-limit-spacer"></span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        } @else if (controllableItem.showIndicator) {
          <div class="section section--indicator pointer-events-auto cursor-pointer" (click)="click.emit()">
            <div class="content">
              <div
                class="item"
                [class.has-value]="controllableItem.hasValue"
                [class.has-icon]="controllableItem.hasIcon"
                [class.has-label]="controllableItem.hasLabel"
                [class.has-color]="controllableItem.hasColor"
                [ngStyle]="{
                  'background-color': controllableItem.backgroundColor,
                  color: controllableItem.color,
                }"
              >
                @if (
                  controllableItem.hasIcon &&
                  !(controllableItem.hasLabel || (controllableItem.hasLabel && !controllableItem.hasValue))
                ) {
                  <cue-icon [icon]="controllableItem.data.iconUrl" [customIconClass]="'icon'" />
                }
                @if (controllableItem.hasValue) {
                  <span class="item__value">{{ controllableItem.data?.value | cmLocalizedString }}</span>
                }
              </div>

              @if (controllableItem.hasLabel) {
                @if (controllableItem.hasIcon && controllableItem.hasValue) {
                  <cue-icon [icon]="controllableItem.data.iconUrl" [customIconClass]="'icon'" />
                }
                <span class="label">{{ controllableItem.data.label | cmLocalizedString }}</span>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</cue-declarative-map-marker>
